<div class="iss-drawer-container"
     [style.width]="context.width"
     [style.max-width]="context.maxWidth"
     @issSlideInRight
>
  <ng-container *polymorpheusOutlet="context.content as content; context: context">
    {{ content }}
  </ng-container>
</div>
